<template>
  <div class="uk-flex uk-flex-column">

    <small-slims-loader v-if="isLoading || data === null"></small-slims-loader>
    
    <div v-if="!isLoading || data !== null" class="uk-text-bold">{{data.type}}</div>
    
    <div v-if="!isLoading && data !== null"
         class="uk-grid uk-grid-divider uk-padding-bottom-small uk-flex-nowrap uk-grid-medium" data-uk-grid>
      <div>
        <span class="uk-text-small"><span data-uk-icon="icon:clock" :data-uk-tooltip="yesterdayDates[0]" class="uk-margin-small-right uk-text-primary"></span>Yesterday</span>
        <div>
          <h1 class="uk-heading-primary uk-margin-remove uk-text-primary"><span
              class="small-font">$</span>{{ data.totalYesterday | formatShortMoney }} </h1>
        </div>
        <div class="uk-text-small ">
          <span :class="getTextColor(data.changeYesterday)"
                :data-uk-icon="getIcon(data.changeYesterday)">{{ data.changeYesterday | formatPctChange }}</span> from LY
        </div>
      </div>
      <div>
        <span class="uk-text-small"><span class="uk-margin-small-right uk-text-primary"><i v-if="rolling7Dates[0] === undefined" :data-uk-tooltip="`title: Loading Date Range...`"  class="fa fa-calendar-minus-o" aria-hidden="true"/><i v-if="rolling7Dates[0] !== undefined" :data-uk-tooltip="`title:` + rolling7Dates[0] + ` - ` + rolling7Dates[1]" class="fa fa-calendar-minus-o" aria-hidden="true"/></span>Rolling 7 Day Average</span>
        <div>
          <h1 class="uk-heading-primary uk-margin-remove uk-text-primary"><span class="small-font">$</span>{{ data.totalRolling7 | formatShortMoney }}</h1>
        </div>
        <div class="uk-text-small ">
          <span :class="getTextColor(data.changeRolling7)"
                :data-uk-icon="getIcon(data.changeRolling7)">{{ data.changeRolling7 | formatPctChange }}</span> from LY
        </div>
      </div>

      <div>
        <span class="uk-text-small"><span class="uk-margin-small-right uk-text-primary"><i v-if="periodDates[0] === undefined" :data-uk-tooltip="`title: Loading Date Range...`" class="fa fa-calendar-o" aria-hidden="true"></i><i v-if="periodDates[0] !== undefined" :data-uk-tooltip="`title:` + periodDates[0] + ` - ` + periodDates[1]" class="fa fa-calendar-o" aria-hidden="true"></i></span>Period</span>
        <div>
          <h1 class="uk-heading-primary uk-margin-remove uk-text-primary"><span
              class="small-font">$</span>{{ data.totalPeriod | formatShortMoney }}</h1>
        </div>
        <div class="uk-text-small ">
          <span :class="getTextColor(data.changePeriod)"
                :data-uk-icon="getIcon(data.changePeriod)">{{ data.changePeriod | formatPctChange }}</span> from LY
        </div>
      </div>

      <div>
        <span class="uk-text-small"><span class="uk-margin-small-right uk-text-primary"><i v-if="ytdDates[0] === undefined" :data-uk-tooltip="`title: Loading Date Range...`" class="fa fa-calendar" aria-hidden="true"></i><i v-if="ytdDates[0] !== undefined" :data-uk-tooltip="`title:` + ytdDates[0] + ` - ` + ytdDates[1]" class="fa fa-calendar" aria-hidden="true"></i></span>YTD</span>
        <div>
          <h1 class="uk-heading-primary uk-margin-remove uk-text-primary"><span
              class="small-font">$</span>{{ data.totalYtd | formatShortMoney }}</h1>
        </div>
        <div class="uk-text-small ">
          <span :class="getTextColor(data.changeYtd)"
                :data-uk-icon="getIcon(data.changeYtd)">{{ data.changeYtd | formatPctChange }}</span> from LY
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import axios from "axios";
import SmallSlimsLoader from "./Components/SmallSlimsLoader";
import SmallLoaderComponent from "../../../Assets/js/Shared/SmallLoaderComponent.vue";

export default {
  name: "CompSalesCard",
  components: {
    SmallLoaderComponent,
    SmallSlimsLoader
  },

  data() {
    return {
      data: null,
      isLoading: false,
    }
  },

  props: {
    yesterdayDates: Array,
    rolling7Dates: Array,
    periodDates: Array,
    ytdDates: Array
  },

  methods: {
    goToDetail(metric) {
      this.eventHub.$emit("compDetailPage", metric);
    },

    getTextColor(data) {
      if (data > 0)
        return "uk-text-success"
      else
        return "uk-text-danger"
    },

    getIcon(data) {
      if (data > 0)
        return "icon: triangle-up"
      else
        return "icon: triangle-down"
    },
  },


  filters: {
    formatShortMoney(num) {
      if (num > 1000 && num < 1000000)
        return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + ' k' : Math.sign(num) * Math.abs(num);

      if (num > 1000000)
        return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000000).toFixed(1)) + ' m' : Math.sign(num) * Math.abs(num);
    },

    formatPctChange: function (number) {
      if (number === null)
        return 'Null';
      
      number = number.toString();
      number += '%';
      
      return number;
    }
  },
  
  mounted() {
    this.isLoading = true;
    
    let me = this;
    const token = this.getTokenSilently();
    const url = this.getApiUrl();
    const clientId = this.getClientId();

    //Franchise
    axios.get(`${url}/api/slims-report/franchise/overall-sales-kpi`, {
      headers: {Authorization: `Bearer ${token}`},
      params: {clientId: clientId}
    })
        .then(response => {
          me.data = response.data[0];
        })
        .catch(err => {
        })
        .finally(() => {
          this.isLoading = false;
        });


  }
}
</script>

<style scoped>


.small-font {
  font-size: 20px;
}

div:not(#loader) {
  white-space: pre;
}

.sys-total-label {
  padding-top: 62px;
}
</style>